import { Controller } from '@hotwired/stimulus'

const STORAGE_KEY = 'collapsedSections'
const SECTION_SELECTOR = '[data-controller~="collapsible-section"]'

export default class extends Controller {
  static targets = ['label', 'caret']

  connect () {
    this.boundUpdate = this.update.bind(this)
    window.addEventListener('collapsible-section:changed', this.boundUpdate)
    document.addEventListener('turbo:load', this.boundUpdate)
    this.update()
  }

  disconnect () {
    window.removeEventListener('collapsible-section:changed', this.boundUpdate)
    document.removeEventListener('turbo:load', this.boundUpdate)
  }

  toggle (event) {
    event.preventDefault()
    const sections = this.sections()
    if (sections.length === 0) return

    const collapsed = this.shouldCollapseNext
    this.persistBulk(sections, collapsed)
    window.dispatchEvent(new CustomEvent('collapsible-sections:set-all', {
      detail: { collapsed }
    }))
    this.update()
  }

  update () {
    const sections = this.sections()
    if (sections.length < 2) {
      this.element.classList.add('hidden')
      return
    }
    this.element.classList.remove('hidden')

    const prefix = window.location.pathname + ':'
    const stored = new Set(this.readState())
    const allExpanded = sections.every((s) => !stored.has(prefix + s.dataset.collapsibleSectionKeyValue))
    this.shouldCollapseNext = allExpanded
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = allExpanded ? 'Collapse All' : 'Expand All'
    }
    if (this.hasCaretTarget) {
      this.caretTarget.classList.toggle('rotate-180', allExpanded)
    }
  }

  sections () {
    return Array.from(document.querySelectorAll(SECTION_SELECTOR))
  }

  persistBulk (sections, collapsed) {
    const prefix = window.location.pathname + ':'
    const stored = this.readState()
    const others = stored.filter((k) => k.indexOf(prefix) !== 0)
    const next = collapsed
      ? [...others, ...sections.map((s) => prefix + s.dataset.collapsibleSectionKeyValue)]
      : others
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
    } catch {
      // localStorage unavailable; ignore
    }
  }

  readState () {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
    } catch {
      return []
    }
  }
}
